import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: 'I already tried things and they did not work. Why would this be different?',
    a: 'What you tried before was probably attacking the symptom — the behavior — without touching the emotional structure that keeps it active. The P-G-E Cycle works on the real mechanism: the neuro-emotional loop. That is what makes the difference.'
  }, {
    q: 'How much time a day do I need?',
    a: 'The practices are designed for 5 to 15 minutes a day. They require no equipment, no special space, and nobody else has to know. If you have time for the cycle, you have time to interrupt it.'
  }, {
    q: 'Does this replace therapy?',
    a: 'It does not replace therapy — it complements it. But it works independently for anyone without access to therapy right now, or who prefers to work on their process privately. Note: if you are in a crisis situation, seek clinical care first.'
  }, {
    q: 'What if I relapse during the 21 days?',
    a: 'The system accounts for that. It is not a promise of perfection — it is a process of progressive redirection. A relapse during the process does not erase the work you have done. It is information, not failure.'
  }, {
    q: 'Does it work for any kind of addiction or compulsion?',
    a: 'If you recognize the P-G-E Cycle in your experience — whatever the behavior is — the system is designed for you. The emotional mechanism is the same in most addictions and compulsions.'
  }, {
    q: 'What format does the complete material come in?',
    a: 'All the material comes in digital PDF format. It arrives by email immediately after purchase — no waiting.'
  }];
  return <section className="py-6 md:py-9 px-5 bg-[radial-gradient(ellipse_at_left,rgba(107,0,182,0.1)_0%,transparent_60%),var(--dark-bg)]" data-id="element-25" data-mp="3uc9bmy3yay0m">
      <div className="max-w-[900px] mx-auto" data-id="element-26" data-mp="1ya4v0ru19wv8">
        <span className="inline-block font-heading font-bold text-[0.75rem] tracking-[3px] uppercase text-magenta-bright mb-2" data-id="element-27" data-mp="1yb7hmnkbpd5c">
          Frequently asked questions
        </span>
        <h2 className="text-[clamp(1.6rem,4vw,2.5rem)] font-heading font-black leading-[1.15] mb-3" data-id="element-28" data-mp="285ptwh3t2h0r">
          What you might be
          <br data-id="element-29" data-mp="2h7z04us1jo8c" />
          <span className="text-gradient-magenta" data-id="element-30" data-mp="2h88oyf1cnpcg">wondering right now</span>
        </h2>
        <div className="mt-4 space-y-2" data-id="element-31" data-mp="2m725yhfuhyhd">
          {faqs.map((faq, idx) => {
          const isOpen = openIndex === idx;
          return <div key={idx} className={`bg-[rgba(107,0,182,0.08)] border rounded-[14px] overflow-hidden transition-[border-color] duration-300 ${isOpen ? 'border-[rgba(194,0,111,0.4)]' : 'border-[rgba(107,0,182,0.25)] hover:border-[rgba(194,0,111,0.4)]'}`} data-id="element-32" data-mp="2qz3crnu8ux00" data-mpi={idx}>
                <button onClick={() => setOpenIndex(isOpen ? null : idx)} aria-expanded={isOpen} className="w-full bg-transparent border-none text-white font-heading font-bold text-[0.95rem] text-left py-3.5 px-5 cursor-pointer flex justify-between items-center gap-4" data-id="element-33" data-mp="34y326xpkzfx8">
                  {faq.q}
                  <span className={`text-magenta-bright text-[1.4rem] shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-45' : 'rotate-0'}`} data-id="element-34" data-mp="fb6yo789wz5d">
                    +
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-35" data-mp="181gnbbx87n5h">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-36" data-mp="1369mqcz96yks">
                      <div className="px-5 pb-3.5 text-[0.92rem] leading-[1.6] text-white/75" data-id="element-37" data-mp="11jltpdpzd9di">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}